var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handover-component"},[_c('IslandBadge',{attrs:{"type":"humanhandover","draggable":false}}),_c('div',{staticClass:"component-contents"},[_vm._v("\n\t\tPause Bot\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }